import camelCase from 'lodash/camelCase';

export const filterObjectByRole = (object, role) =>
  Object.keys(object)
    .filter(key => key.includes(role))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: object[key],
      };
    }, {});

export const removeRoleFromKey = (object, role) => {
  Object.keys(object).forEach(key => {
    object[camelCase(key.replace(role, ``))] = object[key];
    delete object[key];
  });

  return object;
};

/**
 * Read assessment types for a project, migrating from old single-value key if needed.
 */
export const getProjectAssessmentTypes = (projectId) => {
  const newKey = 'project_types_' + projectId;
  const oldKey = 'project_type_' + projectId;

  const stored = localStorage.getItem(newKey);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      return [];
    }
  }

  // Migrate from old single-value key
  const oldValue = localStorage.getItem(oldKey);
  if (oldValue) {
    const types = [oldValue];
    localStorage.setItem(newKey, JSON.stringify(types));
    return types;
  }

  return [];
};

/**
 * Add an assessment type to a project's types array.
 */
export const addProjectAssessmentType = (projectId, type) => {
  const types = getProjectAssessmentTypes(projectId);
  if (!types.includes(type)) {
    types.push(type);
    localStorage.setItem('project_types_' + projectId, JSON.stringify(types));
  }
  return types;
};

export const mergeProjectsAndModels = (projects, stressModels) => {
  const projectsWithType = projects.map(object => {
    const assessmentTypes = getProjectAssessmentTypes(object.id);
    const stressModelId = localStorage.getItem('project_stress_model_' + object.id);

    // Include 'stress' in types if a stress model is linked
    const allTypes = stressModelId && !assessmentTypes.includes('stress')
      ? [...assessmentTypes, 'stress']
      : assessmentTypes;

    return {
      ...object,
      type: 'project',
      assessmentTypes: allTypes,
      stressModelId: stressModelId || null,
      // Keep assessmentType for backward compat with components that read it
      assessmentType: allTypes[0] || 'human_capital',
    };
  });

  // Only include stress models that are NOT linked to any project
  const linkedStressModelIds = new Set(
    projectsWithType
      .filter(p => p.stressModelId)
      .map(p => p.stressModelId)
  );

  const unlinkedStressModels = stressModels
    .filter(m => !linkedStressModelIds.has(m.id))
    .map(object => ({
      ...object,
      type: 'model',
      assessmentTypes: ['stress'],
      assessmentType: 'stress',
    }));

  return [...projectsWithType, ...unlinkedStressModels].sort(
    (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
  );
};
